import LegalLayout, { Section } from "../LegalLayout";
import { BUSINESS } from "../businessInfo";

export default function ShippingPage() {
  return (
    <LegalLayout
      title="Shipping & Service Delivery Policy"
      intro={
        <p>
          {BUSINESS.brandName} is a software-as-a-service platform. There is no physical product
          shipped. This policy explains how the digital service is delivered, and how food orders
          placed through Merchants are fulfilled.
        </p>
      }
    >
      <Section heading="1. Digital service delivery">
        <p>
          When you subscribe to {BUSINESS.brandName}, access is provisioned to your account
          electronically, normally immediately after a successful payment. You use the service over the
          internet at {BUSINESS.website} and through our apps — nothing is physically shipped.
        </p>
      </Section>

      <Section heading="2. Activation timing">
        <p>
          Subscriptions and plan upgrades activate as soon as the payment is confirmed by our payment
          partner (Razorpay). If activation has not happened within a few minutes of a successful
          payment, contact{" "}
          <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
            {BUSINESS.supportEmail}
          </a>.
        </p>
      </Section>

      <Section heading="3. Food order fulfilment">
        <p>
          Food and beverage orders placed by guests through a Merchant's QR menu are prepared and
          delivered (to the table or room) by that Merchant, according to the Merchant's own timelines.
          {" "}{BUSINESS.brandName} provides the ordering technology and does not prepare, deliver, or
          guarantee any food order.
        </p>
      </Section>

      <Section heading="4. Support">
        <p>
          For any delivery or activation issue, reach us at{" "}
          <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
            {BUSINESS.supportEmail}
          </a>{" "}or {BUSINESS.supportPhone} ({BUSINESS.supportHours}).
        </p>
      </Section>
    </LegalLayout>
  );
}
